import { useQuery } from "@tanstack/react-query";
import { getItems } from "./items";

export const useOrdersPaymentsByBankTransactionId = (bankTransactionId: string | number) => {
    const queryResult = useQuery({
        queryKey: ["orders_payments_by_bank_transaction", bankTransactionId],
        queryFn: async () => {
            if (!bankTransactionId) {
                return [];
            }

            const result = await getItems("orders_payments", "id,amount", {
                filter: {
                    connected_bank_transaction_id: {
                        _eq: bankTransactionId,
                    },
                },
                pageSize: 500,
            });

            return result.items;
        },
        enabled: !!bankTransactionId,
        staleTime: 5 * 60 * 1000,
    });

    return queryResult;
};

